import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { BuyService } from '../../services/buyservice'
@Component({
  selector: 'app-order-success',
  templateUrl: './order-success.component.html',
  styleUrls: ['./order-success.component.css']
})
export class OrderSuccessComponent implements OnInit {

  idd;
  dataItem;
  constructor(private route: ActivatedRoute, public buy: BuyService) { }

  ngOnInit() {
    
    this.idd = this.route.snapshot.params['id'];
    this.dataItem = this.buy.getBuyItem(this.idd);

    if (this.dataItem != null) {
      sessionStorage.setItem("is_reloaded_success", JSON.stringify(this.dataItem))
    } else {
      this.dataItem = JSON.parse(sessionStorage.getItem("is_reloaded_success"))
    }
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/order-success/order-success.component.ts